// @flow

export type BetAmountValidationType = {
  message: string,
  amount: number
};

const betAmountValidation = (
  amount: number,
  minimum: number
): BetAmountValidationType => {
  const errorMessage = "You selected an incorrect bet size, we rounded it to: ";
  const result = {
    message: "",
    amount
  };

  if (amount < minimum || isNaN(amount)) {
    result.message = errorMessage + minimum;
    result.amount = minimum;
  } else if (amount < 1) {
    const remnant = ((amount * 100) % (minimum * 100)) / 100;
    if (remnant !== 0) {
      const newAmount = Math.floor(amount / minimum) * minimum;
      result.message = errorMessage + newAmount;
      result.amount = newAmount;
    }
  } else if (!Number.isInteger(amount)) {
    result.message = errorMessage + parseInt(amount, 10);
    result.amount = parseInt(amount, 10);
  }

  return result;
};

export default betAmountValidation;
